import { type SortOrder, type SorterResult } from 'antd/es/table/interface'

import {
  type GetStatisticsAuthorsQueryFinishedSuccessResultAuthorsItem,
  type GetStatisticsAuthorsQueryStart,
} from '../../api'

export type GetAuthorStatisticsQuerySortBy =
  GetStatisticsAuthorsQueryStart['params']['SortBy']

type GetAuthorStatisticsSortableKeys = keyof Omit<
  GetStatisticsAuthorsQueryFinishedSuccessResultAuthorsItem,
  'id' | 'authors' | 'type'
>

const ORDER_AMOUNT = 2

/**
 * Массив в фиксированном порядке — порядок важен!
 * Индекс = sortBy / 2
 */
const sortableFields = [
  'nickname',
  'tracksListensCount',
  'tracksListens50Count',
  'tracksListens75Count',
  'tracksListens95Count',
  'tracksSharesCount',
  'tracksSearchCount',
  'tracksSwapsCount',
  'tracksLikesCount',
  'tracksDislikesCount',
  'tracksPlaylistsCount',
  'likesCount',
  'dislikesCount',
] as const satisfies readonly GetAuthorStatisticsSortableKeys[]

type SortableField = (typeof sortableFields)[number]

export const parseAuthorsStatisticsSortByToSorterResult = (
  sortBy: GetAuthorStatisticsQuerySortBy,
): SorterResult<GetStatisticsAuthorsQueryFinishedSuccessResultAuthorsItem> | null => {
  if (!sortBy && typeof sortBy !== 'number') return null
  const fieldIndex = Math.floor(sortBy / ORDER_AMOUNT)
  const field = sortableFields[fieldIndex]
  const order: SortOrder = sortBy % ORDER_AMOUNT === 0 ? 'ascend' : 'descend'
  return { field, order }
}

export const parseAuthorsStatisticsSorterResultToSortBy = (
  sorterResult: SorterResult<GetStatisticsAuthorsQueryFinishedSuccessResultAuthorsItem>,
): GetAuthorStatisticsQuerySortBy => {
  if (!sorterResult || !sorterResult.field || !sorterResult.order) return
  const fieldIndex = sortableFields.indexOf(sorterResult.field as SortableField)
  return (fieldIndex * ORDER_AMOUNT +
    (sorterResult.order === 'descend'
      ? 1
      : 0)) as GetAuthorStatisticsQuerySortBy
}

export const getAuthorsStatisticsSortOrderByField = (
  sorterResult: SorterResult<GetStatisticsAuthorsQueryFinishedSuccessResultAuthorsItem> | null,
  field: SortableField,
): SortOrder =>
  sorterResult && sorterResult.field === field && sorterResult.order
    ? sorterResult.order
    : null
